import { render, staticRenderFns } from "./RedirectToHome.vue?vue&type=template&id=409bdcd0&scoped=true&"
import script from "./RedirectToHome.vue?vue&type=script&lang=js&"
export * from "./RedirectToHome.vue?vue&type=script&lang=js&"
import style0 from "./RedirectToHome.vue?vue&type=style&index=0&id=409bdcd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bdcd0",
  null
  
)

export default component.exports